import type { BaziChart, CalculateChartReq, ReportDetail } from '@guanwei/shared';
import { api, postStream } from './api';

/** 命盘（无需登录） */
export async function calculateChart(req: CalculateChartReq): Promise<BaziChart> {
  return api.post<BaziChart>('/charts/calculate', req, { auth: false });
}

/** 命盘 + 落库（需要登录） */
export async function createChart(req: CalculateChartReq) {
  return api.post<{ chartId: string; displayName: string; bazi: BaziChart; latestReports: ChartLatestReports }>('/charts', req);
}

export type ChartLatestReports = Partial<Record<'brief' | 'full', ReportDetail & { updatedAt?: string }>>;

export interface ChartHistoryItem {
  id: string;
  displayName: string;
  baziKey: string;
  gender: string;
  useTrueSolar: boolean;
  fuzzyHour: boolean;
  chartData: BaziChart;
  latestReports: ChartLatestReports;
  createdAt: string;
  updatedAt: string;
}

/** 列出当前用户命盘 */
export async function listMyCharts() {
  return api.get<ChartHistoryItem[]>('/charts');
}

/** 命盘详情 */
export async function getChartDetail(chartId: string) {
  return api.get<{
    id: string;
    displayName: string;
    bazi: BaziChart;
    birthInfo: {
      date: string;
      time: string | null;
      gender: string;
      longitude: number | null;
      birthplace: string | null;
      useTrueSolar: boolean;
    };
    latestReports: ChartLatestReports;
  }>(`/charts/${chartId}`);
}

/** 流式生成简版报告 */
export function streamBriefReport(
  chartId: string,
  handlers: {
    onChunk: (delta: string) => void;
    onDone: (reportId: string | undefined) => void;
    onError: (msg: string) => void;
  },
  modelCode?: string,
): { abort: () => void } {
  const controller = new AbortController();
  postStream(
    `/reports/charts/${chartId}/brief/stream`,
    { modelCode },
    {
      onEvent: (event, data) => {
        if (event === 'chunk') {
          handlers.onChunk((data as { delta: string }).delta);
        } else if (event === 'done') {
          handlers.onDone((data as { reportId?: string }).reportId);
        } else if (event === 'error') {
          handlers.onError(
            (data as { message?: string }).message ?? '生成失败',
          );
        }
      },
      onError: (err) => handlers.onError(err.message),
    },
    { signal: controller.signal },
  );
  return { abort: () => controller.abort() };
}
